import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SidebarIconSearch from './sidebar-icon-search.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SidebarIconSearch {...validProps} />;
}
SvgComponent.iconName = 'sidebarIconSearch';

/**
 * @deprecated This is a legacy icon
 */
export const SidebarIconSearchIcon = svgIconWrapper(SvgComponent);
